import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { LoginGoogleRedirect1 } from './LoginGoogleRedirect1';
import LoginOktaRedirect from './LoginOktaRedirect';
import { oktaAuthConfig, oktaSignInConfig } from './oktaConfig';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import {LoginMicrosoftRedirect} from './LoginMicrosoftRedirect';

const oktaAuth = new OktaAuth(oktaAuthConfig);

export const LoginRedirectPage = ({ setUserInfo }) => {
    // const appContext = useContext(AppContext);
    const history = useHistory();

    const customAuthHandler = () => {
        history.push('/login-redirect-okta');
    };

    return (
        <Security
            oktaAuth={oktaAuth}
            onAuthRequired={customAuthHandler}
        >
            <Switch>
                <Route exact path='/login-redirect-google'><LoginGoogleRedirect1 /></Route>
                <Route exact path='/login-redirect-microsoft'><LoginMicrosoftRedirect /></Route>
                {/* <Route exact path='/login-redirect-okta'><LoginOktaRedirect config={oktaSignInConfig} setUserInfo={setUserInfo} /></Route> */}
            </Switch>
        </Security>
    )
}